<template>
  <validation-provider
    v-slot="{ errors }"
    :name="label"
    :rules="rules"
  >
    <v-select
      v-model="inputVal"
      :error-messages="errors"
      :item-text="itemText"
      :item-value="itemValue"
      :items="items"
      :label="label"
      :hint="hint"
      :required="required && !disabled"
      :disabled="disabled"
      @change="change"
    />
  </validation-provider>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import { required } from 'vee-validate/dist/rules';
import {
  setInteractionMode, ValidationProvider, extend,
} from 'vee-validate';
import { getValidationRule, getHint } from '@/lib/ValidationRules';

export default {
  components: {
    ValidationProvider,
  },
  props: {
    validationRule: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    items: {
      type: Array,
      required: true,
    },
    itemText: {
      type: String,
      required: false,
      default: 'text',
    },
    itemValue: {
      type: String,
      required: false,
      default: 'value',
    },
    change: {
      type: Function,
      required: false,
      default: () => null,
    },
  },
  data: () => ({
    rules: '',
    hint: '',
  }),
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  created() {
    setInteractionMode('aggressive'); // TODO: set in parent form?! 'lazy'
    if (this.validationRule) {
      getValidationRule(this.validationRule);
      getHint(this.validationRule);
    }
    // eslint-disable-next-line max-len
    if (this.required) {
      extend('required', {
        ...required,
        message: '{_field_} is required!',
      });
    }
    this.rules = `${(this.required && !this.disabled) ? 'required|' : ''}${this.validationRule}`;
  },
};
</script>
